<template>
  <section class="news">
    <article v-for="n in items" :key="n.title" class="card">
      <span class="mono kicker">{{ n.kicker }}</span>
      <h3 class="display">{{ n.title }}</h3>
      <p>{{ n.body }}</p>
    </article>

    <!-- 4th cell: Explore CTA -->
    <a href="#solutions" class="card cta" aria-label="Explore services">
      <span class="mono kicker">Fast Turnaround · Genuine Parts</span>
      <span class="cta-arrow" aria-hidden="true">
        <svg viewBox="0 0 100 100" width="72" height="72">
          <path d="M22 78 L78 22 M40 22 H78 V60" fill="none" stroke="currentColor"
                stroke-width="12" stroke-linecap="square" stroke-linejoin="miter"/>
        </svg>
      </span>
      <h3 class="display">Explore our<br>repair services.</h3>
    </a>
  </section>
</template>

<script>
import { gsap } from '@/composables/useReveal'

export default {
  name: 'NewsSection',
  data() {
    return {
      items: [
        { kicker: 'Express Service', title: 'Same-Day Device Repair, Expertly Managed', body: 'From screens and keyboards to batteries and performance faults, most everyday repairs are completed fast with careful diagnostic control.' },
        { kicker: 'Genuine Parts', title: 'Quality Components. Reliable Results.', body: 'Every replacement part is chosen for fit, performance and long-term durability, then checked through a strict service and testing process.' },
        { kicker: 'Data Safe', title: 'Recovery First. Privacy Always.', body: 'When a system fails, we prioritise file recovery and handle every device with a security-first workflow that keeps your information protected.' }
      ]
    }
  },
  mounted() {
    gsap.fromTo(this.$el.querySelectorAll('.card'),
      { yPercent: 12, opacity: 0, clipPath: 'inset(0 0 100% 0)' },
      {
        yPercent: 0, opacity: 1, clipPath: 'inset(0 0 0% 0)',
        clearProps: 'opacity,transform,clipPath',
        duration: 1.05, ease: 'power4.out', stagger: 0.12,
        scrollTrigger: { trigger: this.$el, start: 'top 82%', once: true }
      }
    )
    // inner content lifts in slightly after the card
    gsap.from(this.$el.querySelectorAll('.card > *'), {
      y: 24, opacity: 0, clearProps: 'opacity,transform', duration: 0.8, ease: 'power3.out',
      stagger: { each: 0.05, grid: [1, 4], from: 'start' }, delay: 0.25,
      scrollTrigger: { trigger: this.$el, start: 'top 82%', once: true }
    })
  }
}
</script>

<style scoped>
.news {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) var(--rail-width, minmax(0, 1fr));
  background: var(--ink);
  gap: 1px;
}
.card {
  background: var(--grey); color: var(--ink);
  padding: clamp(32px, 3vw, 46px);
  display: flex; flex-direction: column; min-height: 340px;
  transition: background 0.4s var(--ease), transform 0.5s var(--ease);
  will-change: transform; text-decoration: none;
}
.card:hover { background: var(--grey-2); transform: translateY(-8px); }
.kicker { font-size: 11px; letter-spacing: 2px; color: var(--coral-deep); }
.card h3 {
  font-size: clamp(24px, 2.2vw, 34px);
  letter-spacing: -1px;
  margin: 22px 0 16px;
  line-height: 1.02;
  min-height: 3.15em;
}
.card p { color: #45454a; font-size: 15px; line-height: 1.6; margin: 0; flex: 1; }

/* 4th cell — coral explore CTA */
.card.cta { background: var(--coral); color: var(--ink); justify-content: space-between; }
.card.cta:hover { background: var(--coral-deep); transform: translateY(-8px); }
.card.cta .kicker { color: var(--ink); }
.card.cta h3 { margin: 0; }
.cta-arrow { color: var(--ink); margin: clamp(20px, 3vw, 36px) 0; transition: transform 0.4s var(--ease); }
.cta-arrow svg { display: block; }
.card.cta:hover .cta-arrow { transform: translate(8px, -8px); }

@media (max-width: 1100px) { .news { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 620px) { .news { grid-template-columns: 1fr; } }
</style>
